import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { routing } from "@i18n/routing";

const localeSet = new Set<string>(routing.locales);

export const useScrollDownButton = () => {
    const [atTop, setAtTop] = useState(true);
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
    const pathname = usePathname();
    const pathSegments = pathname?.split("/").filter(Boolean) ?? [];
    const pageSegments = localeSet.has(pathSegments[0]) ? pathSegments.slice(1) : pathSegments;
    const isEccoKollektivePage = pageSegments.length === 1 && pageSegments[0] === "ecco-kollektive";

    useEffect(() => {
        const onScroll = () => setAtTop(window.scrollY < 50);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    useEffect(() => {
        const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
        setPrefersReducedMotion(mediaQuery.matches);
        const onChange = () => setPrefersReducedMotion(mediaQuery.matches);
        mediaQuery.addEventListener("change", onChange);
        return () => mediaQuery.removeEventListener("change", onChange);
    }, []);

    const handleScrollDown = () => {
        window.scrollBy({
            top: window.innerHeight,
            behavior: prefersReducedMotion ? "auto" : "smooth",
        });
    };

    return { atTop, handleScrollDown, prefersReducedMotion, isEccoKollektivePage };
};
